// @flow
import * as React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import TextField from './TextField';
import type { Props as TextFieldProps } from './TextField';
import { Icon } from 'components/atoms/Icon/';

import './TextFieldWithIcon.scss';

export type Props = {
  /**
   * The icon to shown on the left side of the input
   */
  icon: string,
  /**
   * A custom TextField component to use
   */
  component?: React.ComponentType<any>
} & TextFieldProps;

export default function TextFieldWithIcon({
  icon,
  component: C,
  isInvalid,
  ...rest
}: Props) {
  const ns = TextFieldWithIcon.block;
  const rootClassName = cn({
    [ns]: true,
    [`${ns}--is-invalid`]: isInvalid
  });
  const ComputedComponent = C || TextField;

  // TODO: remove default messages once localization string are ready
  const ariaLabel = {
    id: '',
    defaultMessage: ''
  };

  switch (icon) {
    case 'oldMobile':
      ariaLabel.id = 'c8.aria.contact.mobile.phone.number';
      ariaLabel.defaultMessage = 'Contact mobile phone number';
      break;
    case 'oldPhone':
    case 'phone':
      ariaLabel.id = 'c8.aria.contact.home.phone.number';
      ariaLabel.defaultMessage = 'Contact home phone number';
      break;
    case 'email':
    default:
      ariaLabel.id = 'c8.aria.contact.email.address';
      ariaLabel.defaultMessage = 'Contact email address';
      break;
  }

  return (
    <span className={rootClassName}>
      <span className={`${ns}__icon-wrapper`}>
        <FormattedMessage
          id={ariaLabel.id}
          defaultMessage={ariaLabel.defaultMessage}
        >
          {text => (
            <Icon className={`${ns}__icon`} type={icon} aria-label={text} />
          )}
        </FormattedMessage>
      </span>
      <ComputedComponent
        className={`${ns}__input`}
        isInvalid={isInvalid}
        {...rest}
      />
    </span>
  );
}

TextFieldWithIcon.block = 'text-field-with-icon';



// WEBPACK FOOTER //
// ./src/components/api/components/TextField/TextFieldWithIcon.js